// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2c93531a","182":"def67d54"}[chunkId] + ".chunk.js";
};